import { useContext } from "react";
import { UnidentifiedCreationInfo } from "../../../../generated/data-contracts";
import { AvisField, AvisSection } from "../../../shared/components/form";
import { AvisContext } from "../../../shared/context";

interface IUnidentifiedCreationCommonDataProps {
  unidentifiedCreation?: UnidentifiedCreationInfo;
}

export function UnidentifiedCreationCommonData(
  props: Readonly<IUnidentifiedCreationCommonDataProps>,
) {
  const { unidentifiedCreation } = props;
  const { res } = useContext(AvisContext);

  if (!unidentifiedCreation) return;

  return (
    <AvisSection>
      <div className="grid">
        <AvisField
          title={res("label_Performer")}
          value={unidentifiedCreation?.performer}
        />
        <AvisField
          title={res("label_Composer")}
          value={unidentifiedCreation?.composer}
        />
        <AvisField
          title={res("label_TextAuthor")}
          value={unidentifiedCreation?.textAuthor}
        />
        <AvisField
          title={res("label_Choreographer")}
          value={unidentifiedCreation?.choreographer}
        />
        <AvisField
          title={res("label_CoFounder")}
          value={unidentifiedCreation?.coFounder}
        />
      </div>
    </AvisSection>
  );
}
